"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorRenderer = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorRenderer = ({
  errors,
  generalErrorKey = '_general'
}) => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  if (!errors || Object.keys(errors).length === 0) {
    return null;
  }
  const errorKeys = Object.keys(errors);
  const renderError = (field, message) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    mb: 2,
    display: "flex",
    justifyContent: "center",
    variant: "caption",
    color: "error.main",
    align: "center",
    children: message
  }, field);
  return errorKeys.map(field => {
    const errorMessage = errors[field]?.message ?? (field === generalErrorKey ? errors[field]?.message : null);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (errorMessage && typeof errorMessage === 'string') {
      return renderError(field, errorMessage);
    }
    return null;
  });
};
exports.ErrorRenderer = ErrorRenderer;
